<template>
  <div>
    <h1 class="display-4 font-weight-lighter">
      Master Account
    </h1>
    <br />

    <div v-if="!loading">
      <b-form-group label="Email" label-cols="2">
        <b-form-input v-model="email" disabled></b-form-input>
      </b-form-group>
      <b-form-group label="Customer" label-cols="2">
        <b-form-select v-model="customer_id" :options="customers.map(i=>({text:i.name,value:i.id}))"></b-form-select>
      </b-form-group>
      <b-row>
        <b-col cols="8"></b-col>
        <b-col>
          <b-overlay :show="saving" spinner-variant="success" spinner-small>
            <b-button variant="success" squared block @click.prevent="save"><i class="fal fa-save"></i> Save</b-button>
          </b-overlay>
        </b-col>
      </b-row>
    </div>
    
    <b-overlay v-else show>
      <div class="my-5"></div>
    </b-overlay>

  </div>
</template>

<script>
import User from '@/models/User';
import CustomerContact from '@/models/CustomerContact';
import Customer from '@/models/Customer';
import ToastNotifications from '@/components/shared/mixins/ToastNotifications';

export default {
  name: 'MasterAccount',
  mixins: [ToastNotifications],
  data() {
    return {
      loading: true,
      saving: false,
      email: 'info@superformicf.ca',
      customer_contact: null,
      customers: [],
      customer_id: null
    };
  },
  methods: {
    save() {
      this.saving = true;
      CustomerContact.api().update(this.customer_contact.id, {customer_id: this.customer_id}).then(() => {
        this.saving = false;
        this.quickSuccessToast('Master account customer updated', 'You can now login as a contact under that customer.');
      }, () => {
        this.saving = false;
        this.quickWarningToast('Could not assign customer', 'Please try again.');
      });
    }
  },
  mounted() {
    try {
      Promise.all([
        Customer.api().fetch({limit: 9999}),
        User.api().fetch({email: this.email})
      ]).then(() => {
        this.customers = Customer.query().orderBy('name').get();
        if(!this.customers || !this.customers.length) {
          throw 'No customers';
        }
        let user = User.query().where('email', this.email).first();
        if(!user) {
          throw 'Missing user';
        }
        CustomerContact.api().fetch({user: user.id}).then(() => {
          this.customer_contact = CustomerContact.query().where('user_id', +(user.id)).first();
          if(!this.customer_contact) {
            throw 'Missing customer contact';
          }
          this.customer_id = this.customer_contact.customer_id;
          this.loading = false;
        });
      }, (err) => {
        throw err;
      });
    } catch(err) {
      this.quickWarningToast('Account Load Failed', err);
      this.loading = false;
    }
  }
}
</script>
